module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "m-news list-unstyled"
  }, _vm._l((_vm.newsCollection), function(news) {
    return _c('li', {
      staticClass: "m-news__item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ReadNews',
          params: {
            id: news.id
          }
        }
      }
    }, [_vm._v(_vm._s(news.title))])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23263458","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/News.vue
// module id = 706
// module chunks = 1